import AddressManager from "../Shared/AddressManager";
import ImageCache from "../Shared/ImageCache";
import UIManager from "../Shared/UIManager";
import { Global } from "../Shared/Global";

const {ccclass, property} = cc._decorator;

@ccclass
export default class SettingLayerDevelop extends cc.Component {
    @property(cc.Toggle)
    toggleTest1: cc.Toggle = null
    @property(cc.Toggle)
    toggleTest2: cc.Toggle = null
    @property(cc.Toggle)
    toggleTest3: cc.Toggle = null
    @property(cc.Toggle)
    toggleGray1: cc.Toggle = null
    @property(cc.Toggle)
    toggleGray2: cc.Toggle = null


    @property(cc.EditBox)
    ebAddress: cc.EditBox = null

    private _isLoaded = false

    onLoad () {
        let serverEnvironment = cc.sys.localStorage.getItem("ServerEnvironment") || "0"

        if (serverEnvironment === "0") {
            this.toggleTest1.isChecked = true
        }else if (serverEnvironment === "1") {
            this.toggleTest2.isChecked = true
        }else if (serverEnvironment === "3") {
            this.toggleTest3.isChecked = true
        }
        else if (serverEnvironment === "4") {
            this.toggleGray1.isChecked = true
        }else if (serverEnvironment === "5") {
            this.toggleGray2.isChecked = true
        }

        this._isLoaded = true
    }
    
    onToggleSelected (toggle: cc.Toggle) {
        if (!this._isLoaded) return

        if (toggle === this.toggleTest1) {
            cc.sys.localStorage.setItem("ServerEnvironment", 0)
        }else if (toggle === this.toggleTest2) {
            cc.sys.localStorage.setItem("ServerEnvironment", 1)
        }else if (toggle === this.toggleTest3) {
            cc.sys.localStorage.setItem("ServerEnvironment", 3)
        }else if (toggle === this.toggleGray1) {
            cc.sys.localStorage.setItem("ServerEnvironment", 4)
        }
        else if (toggle === this.toggleGray2) {
            cc.sys.localStorage.setItem("ServerEnvironment", 5)
        }
        
        AddressManager.setServerDomain("")
        ImageCache.removeCasheDirectory()
        cc.audioEngine.stopAll()
        cc.game.restart()
    }

    onBtnClick (sender, userData) {
        if (userData === "ok") {
            cc.sys.localStorage.setItem("ServerAddress", this.ebAddress.string)
            UIManager.showToastUI("自定义域名设置成功", Global.ToastType.OK)
        }
    }
}
